import Parse from "parse";

import type { Ticket } from "./Ticket";
import type { _Role } from "./_Role";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface ProjectAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  assignedRoles: Parse.Relation<Project, _Role>;
  assignedUsers: Parse.Relation<Project, _User>;
  color?: string;
  description: string;
  end?: Date;
  finished: boolean;
  icon?: string;
  name: string;
  parent?: Project;
  start?: Date;
  tenant?: OD3_Tenant;
  tickets: Parse.Relation<Project, Ticket>;
  user?: _User;
}

export class Project extends Parse.Object<ProjectAttributes> {
  static className: string = "OD3_Maintenance_Project";

  constructor(data?: Partial<ProjectAttributes>) {
    super("OD3_Maintenance_Project", data as ProjectAttributes);
  }

  get assignedRoles(): Parse.Relation<Project, _Role> {
    return super.relation("assignedRoles");
  }
  get assignedUsers(): Parse.Relation<Project, _User> {
    return super.relation("assignedUsers");
  }
  get color(): string | undefined {
    return super.get("color");
  }
  set color(value: string | undefined) {
    super.set("color", value);
  }
  get description(): string {
    return super.get("description");
  }
  set description(value: string) {
    super.set("description", value);
  }
  get end(): Date | undefined {
    return super.get("end");
  }
  set end(value: Date | undefined) {
    super.set("end", value);
  }
  get finished(): boolean {
    return super.get("finished");
  }
  set finished(value: boolean) {
    super.set("finished", value);
  }
  get icon(): string | undefined {
    return super.get("icon");
  }
  set icon(value: string | undefined) {
    super.set("icon", value);
  }
  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
  get parent(): Project | undefined {
    return super.get("parent");
  }
  set parent(value: Project | undefined) {
    super.set("parent", value);
  }
  get start(): Date | undefined {
    return super.get("start");
  }
  set start(value: Date | undefined) {
    super.set("start", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get tickets(): Parse.Relation<Project, Ticket> {
    return super.relation("tickets");
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Project", Project);
